<template>
    <v-card flat>
        <v-card-title class="subheading">
            Publish report - {{reportId.name}}
            <v-spacer/>
            <v-icon @click="closeDialog" small class="grey--text">fas fa-times</v-icon>
        </v-card-title>
        <hr>
        <v-card-text>
         <template v-for="company in companies">
                <v-layout row wrap>
                    <v-flex xs9 class="text-xs-left body-2">
                        {{company.id}}-
                        {{company.name}}
                    </v-flex>
                    <v-flex xs2 class="text-xs-left">
                      <v-btn v-if="companyList.indexOf(company.id)>=0" @click="removeFromCompany(company.id)" 
                          small class="red white--text">
                            Remove
                        </v-btn> 
                        <v-btn v-if="companyList.indexOf(company.id)<0" @click="addToCompany(company.id)"
                             small class="green white--text">
                            Add
                        </v-btn> 
                    </v-flex>
                </v-layout>
            </template>   
        </v-card-text>
    </v-card>
</template>
<script>

import ReportModel from '@/api/service/ReportService';
import CompanyModel from '@/api/service/CompanyService';

export default {
    props: [
        "reportId","reportName"
    ],
    data() {
        return {
            companies: [],
            companyList:[]
        }
    },
    created: function() {
      this.getReports()
    },
    mounted:function () {

    },
    methods: {
        getReports() {
          CompanyModel.findAll({})
            .then(response => {
                this.companies = response
                this.getPublishedReports()
            }).catch(error => {
                console.log(error)
          }); 
        },
        setPublishedData($reports) {
            this.companyList=[]
            //var $companyList
            for(var $i=0;$i<$reports.length;$i++) {
                this.companyList.push($reports[$i].published_reports.company_id)
            }
        },
        addToCompany($companyId) {
            ReportModel.addReportToCompany({"report_id":this.reportId.id,company_id:$companyId})
                .then(response => {
                   this.getPublishedReports()
            }).catch(error => {
                console.log(error)
          });    
        },
        removeFromCompany($companyId) {
            ReportModel.removeFromCompany({"report_id":this.reportId.id,company_id:$companyId})
                .then(response => {
                   this.getPublishedReports()
            }).catch(error => {
                console.log(error)
          });    
        },
        closeDialog() {
            this.$emit('closeDialog')
        },
        getPublishedReports() {
            ReportModel.getReportForCompany2({"id":this.reportId.id})
            .then(response => {
                //this.published = response
                this.setPublishedData(response)
            }).catch(error => {
                console.log(error)
          }); 
        }
    }
}
</script>